<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/features_and_amenities/cashless.jpg" alt=""></transition></div>
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Features & Amenities / Leading Edge Technology" h1="Cashless Payment" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">
                        <Accordian v-for="(accordian, key) in accordians" :key="key" :preview="accordian.preview" :icon="accordian.icon" :info="accordian.info"/>
                    </div>                    
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
//TODO
import PageLeft from "@/patterns/PageLeft.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import Accordian from "@/patterns/Accordian.vue";
export default {
  name: "WifiAndCellCoverage",
  components: { PageLeft, TitleContent, Accordian },
  data: () => ({
    scrollContent: false,    
    accordians:[
      {
        "preview" : "First cashless venue",
        "icon" : "features_and_amenities/icon-white_cashless-waves.svg",
        "info" : [
          "Allegiant Stadium is the first venue in American professional sports to open as a cashless venue"
        ]
      },
      {
        "preview" : "Reduced transaction times",
        "icon" : "features_and_amenities/icon-white_reduced-transaction.svg",
        "info" : [
          "Cashless transactions cut average transaction times in half as compared to traditional points of sale, increasing speed of service, reducing concession lines, and getting fans back in seats faster"
        ]
      },
      {
        "preview" : "Mobile payment methods",
        "icon" : "features_and_amenities/icon-white_mobile-ordering.svg",
        "info" : [
          "Fans can pay for items using valid debit or credit cards, or mobile wallets including Apple Pay, Google Pay, or Samsung Pay"
        ]
      },
      {
        "preview" : "Cash-to-card kiosks",
        "icon" : "features_and_amenities/icon-white_cash-to-card.svg",
        "info" : [
          "Several cash-to-card kiosks are positioned throughout the stadium where fans can exchange cash for a pre-paid card that can be used both inside and outside the stadium"
        ]
      },
      {
        "preview" : "Health benefits",
        "icon" : "features_and_amenities/icon-white_health.svg",
        "info" : [
          "Cashless transactions promote the overall health, security, and public safety of fans by reducing contact during checkout"
        ]
      },
      {
        "preview" : "Mobile app ordering",
        "icon" : "features_and_amenities/icon-white_mobile-ordering.svg",
        "info" : [
          "Mobile app ordering provides fans with the convenience of ordering food and beverage from their seats"
        ]
      },
    ]
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>